import React, {useState} from "react";
import "./index.scss";
const MobileButton = ({
    type = 'filled',
    onClick, 
    children,
    className = '',
    disabled = false
})=>{
        
    const [isActive, setIsActive] = useState(false)
    const getButtonStyle = () => {
        switch (type) {
            case 'filled':
                return 'filled-button'   
            case 'outlined':
                return 'outlined-button'   
            default:
                return 'outlined-button'   
        }
    }
    return  <button
        onClick={onClick}
        onTouchStart={() => setIsActive(true)}
        onTouchEnd={() => setIsActive(false)}
        disabled={disabled}
        className={`MobileButton ${getButtonStyle()} ${isActive && !disabled ? getButtonStyle()+'-active' : ''}  ${disabled ? getButtonStyle()+'-disabled' : ''} ${className}`}
    >
        {children}
    </button>
}

export default MobileButton